import { Component, OnInit, Input, OnDestroy, ElementRef, ViewChild } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';

import { filter } from 'rxjs/operators';
import { DataService, HelperService, HTTPService } from 'app/services';
import { Subscription, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ConfirmDismissDialogComponent } from '../confirm-dismiss-dialog/confirm-dismiss-dialog.component';
import { DialogService } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-bottom-menu',
  templateUrl: './bottom-menu.component.html',
  styleUrls: ['./bottom-menu.component.scss'],
})
export class BottomMenuComponent implements OnInit, OnDestroy {
  @Input() navItems: any[];
  @Input() currentLang: string = 'en';
  @Input() companyLocalization: boolean = false;
  @Input() position: string = 'top';
  @Input() isNotesUpdated: boolean = false;

  unreadNotificationCount: number = 0;
  tsCount: number = 0;
  unsubscribe: Subject<boolean> = new Subject<boolean>();
  link: string = '';
  isHideToolbar: boolean = false;
  subscription: Subscription[] = []
  employeeId: string = '';
  langFlag: boolean = false;

  constructor(private router: Router, private dataService: DataService, private httpService: HTTPService,
    private dialogService: DialogService, private helperService: HelperService) { }

  ngOnInit() {

    this.subscription.push(
      this.helperService.hideBottomDetailsInTechApp.subscribe(status => {
        this.isHideToolbar = status;
      })
    )
    this.setActiveRoute(this.router.url);

    this.httpService.getCompanyPreferredLanguage().then((res: any) => {
      this.companyLocalization = res.localization;
      if (this.companyLocalization) {
        const user = this.helperService.getCompany();
        this.employeeId = user.employeeId;

        this.httpService.getEmployeeDetails(user.employeeId).then((employee: { preferredLanguage?: string }) => {
          if (employee.preferredLanguage) {
            this.currentLang = employee.preferredLanguage.toLowerCase() || 'en';
          }
        });
      } else {
        this.currentLang = 'en';
      }
    });
    // listen to router change events, to set active tab
    this.router.events
      .pipe(takeUntil(this.unsubscribe))
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((activeRoute: any) => {
        const url: string = activeRoute.url;
        this.setActiveRoute(url);
      });

    // listen to data for unread notifications
    this.dataService
      .getData()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(({ data }) => {
        if (data?.data?.unreadNotificationCount != undefined) {
          this.unreadNotificationCount = data.data.unreadNotificationCount;
        }
      });
  }

  async getPreferredLanguage(): Promise<string> {
    try {
      const res: any = await this.httpService.getCompanyPreferredLanguage();
      this.companyLocalization = res.localization;
      if (this.companyLocalization) {
        const user = this.helperService.getCompany();
        this.employeeId = user.employeeId;

        const employee: { preferredLanguage?: string } = await this.httpService.getEmployeeDetails(user.employeeId);
        if (employee.preferredLanguage) {
          this.currentLang = employee.preferredLanguage.toLowerCase() || 'en';
        }
      } else {
        this.currentLang = 'en';
      }
    } catch (error) {
      console.log('Error: ', error);
    }
    return this.currentLang;
  }

  setActiveRoute(url) {
    switch (url) {
      case '/tech/orders':
        this.link = 'orders';
        break;

      case '/tech/appointments':
        this.link = 'appointments';
        break;

      case '/tech/notifications':
        this.link = 'notifications';
        break;

      case '/tech/clock':
        this.link = 'clock';
        break;

      case '/tech/earnings':
        this.link = 'earnings';
        break;

      default:
        this.link = '';
        break;
    }
  }

  navigate(link: string) {
    this.getPreferredLanguage().then((currentLang) => {
      const techUrl = '/tech/';
      if (this.langFlag) return;
      if (this.isNotesUpdated) {
        this.openWarningPrompt(techUrl + link);
      } else {
        this.link = link;
        this.router.navigate([techUrl + link], { queryParams: { lang: currentLang } })
      }
    });
  }

  openWarningPrompt(link) {
    const title = this.currentLang === 'fr' ? 'Revenir en arrière et abandonner les modifications?' : 'Go Back and Discard changes?';
    const message = this.currentLang === 'fr' ? `Vous avez des modifications non enregistrées à l'écran. Revenir en arrière annulera définitivement ces modifications` : `You have unsaved changes on the screen. Going back will permanently discard these changes`;
    const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
      width: '90%',
      styleClass: 'small-heading-dialog',
      showHeader: false,
      data: {
        title,
        message,
        button: {
          success: { title: this.currentLang === 'fr' ? 'Abandonner' : 'Discard' },
          cancel: { title: this.currentLang === 'fr' ? 'Annuler' : 'Cancel' },
        },
      },
    });

    const onCloseSub = ref.onClose.subscribe((confirm) => {
      if (confirm.isSuccess) {
        this.router.navigateByUrl(link);
      }

      onCloseSub.unsubscribe();
    });
  }

  ngOnDestroy() {
    this.unsubscribe.next(true);
    this.unsubscribe.unsubscribe();
    this.subscription.forEach(listener => listener.unsubscribe())
  }
}
